import { formatDistance } from "./en-US/_lib/formatDistance.js";
import { formatLong } from "./en-US/_lib/formatLong.js";
import { formatRelative } from "./en-US/_lib/formatRelative.js";
import { localize } from "./en-US/_lib/localize.js";
import { match } from "./en-US/_lib/match.js";

/**
 *
 *
 *
 *
 *
 *
 */
export const enUS = {
  code: "en-US",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /*        */,
    firstWeekContainsDate: 1,
  },
};

/*                                */
export default enUS;
